const TONE_CLASSES = {
    default: 'border-black dark:border-white text-black dark:text-white',
    accent: 'border-accent text-accent',
    success: 'border-emerald-600 text-emerald-600',
    warning: 'border-amber-600 text-amber-600',
    danger: 'border-red-600 text-red-600',
}

export default function Badge({ tone = 'default', className = '', children }) {
    return (
        <span
            className={[
                'inline-flex items-center gap-1 rounded-none border-2 bg-white px-2 py-0.5 font-mono text-[11px] font-bold uppercase tracking-wide dark:bg-zinc-950',
                TONE_CLASSES[tone] || TONE_CLASSES.default,
                className,
            ].join(' ')}
        >
            {children}
        </span>
    )
}
